import React, { useState, useEffect } from 'react';

function loadYandexMetrika() {
  if (window.ym) return;
  /* eslint-disable */
  (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
  m[i].l=1*new Date();
  for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
  k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
  (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  /* eslint-enable */
  window.ym(0, "init", { clickmap: true, trackLinks: true, accurateTrackBounce: true });
}

function loadVkPixel() {
  if (window.VK) return;
  var t = document.createElement("script");
  t.type = "text/javascript";
  t.async = true;
  t.src = "https://vk.com/js/api/openapi.js?169";
  t.onload = function() {
    if (window.VK && window.VK.Retargeting) {
      window.VK.Retargeting.Init("VK_PIXEL_ID");
      window.VK.Retargeting.Hit();
    }
  };
  document.head.appendChild(t);
}

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('khepri_cookie_consent');
    if (!consent) {
      setVisible(true);
    } else if (consent === 'accepted') {
      loadYandexMetrika();
      loadVkPixel();
    }
  }, []);

  const accept = () => {
    localStorage.setItem('khepri_cookie_consent', 'accepted');
    localStorage.setItem('khepri_cookie_date', new Date().toISOString());
    setVisible(false);
    loadYandexMetrika();
    loadVkPixel();
  };

  const decline = () => {
    localStorage.setItem('khepri_cookie_consent', 'declined');
    localStorage.setItem('khepri_cookie_date', new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#1E293B',
      borderTop: '2px solid #F7DE8A',
      padding: 20,
      zIndex: 9999,
      boxShadow: '0 -4px 12px rgba(0,0,0,0.3)',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
        <div style={{ flex: 1, minWidth: 280 }}>
          <div style={{ color: '#F7DE8A', fontWeight: 700, marginBottom: 6, fontSize: 15 }}>
            🍪 Мы используем cookie
          </div>
          <div style={{ color: '#94A3B8', fontSize: 13, lineHeight: 1.5 }}>
            Для анализа работы сайта мы используем Яндекс.Метрику. Данные хранятся на серверах в России.
            Подробнее — в{' '}
            <a href="/privacy" style={{ color: '#F7DE8A', textDecoration: 'underline' }}>
              Политике обработки персональных данных
            </a>.
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={decline}
            style={{
              padding: '10px 20px',
              background: 'transparent',
              color: '#94A3B8',
              border: '1px solid #8A6636',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            Отклонить
          </button>
          <button
            onClick={accept}
            style={{
              padding: '10px 24px',
              background: '#F7DE8A',
              color: '#0F172A',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 700,
              fontSize: 13,
            }}
          >
            Принять
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;